import { render, staticRenderFns } from "./status_page.vue?vue&type=template&id=27220931"
import script from "./status_page.vue?vue&type=script&lang=js"
export * from "./status_page.vue?vue&type=script&lang=js"
import style0 from "./status_page.vue?vue&type=style&index=0&id=27220931&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports